// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4h-5";
export var imageContainer = "_4h-4";
export var metricsGrid = "_4h-2";
export var productDetailContainer = "_4h-1";
export var productListContainer = "_4h-0";
export var subscriberTableContainer = "_4h-3";